import { networkCall } from "../../../../../util/network-call/network-call";

export const AdminUserAddLoader = async () => {

    const response = await networkCall('/companies');

    return !response ? null : response;

};